<div class="w-full mx-auto rounded-lg max-h-[90vh] flex flex-col">
  <div class="py-2 px-4 flex-shrink-0">
    <div class="titre3">{{ 'PACKAGES_PERSO_MANAGEMENT.EDIT_VIDEO_LANGUAGES' | translate }}</div>
  </div>

  <div class="flex-1 overflow-y-auto p-4 min-h-0">
    <div class="mb-4">
      <div class="mb-4 p-3 bg-gray-50 rounded-md">
        <p class="text-sm text-gray-600">
          {{ 'PACKAGES_PERSO_MANAGEMENT.VIDEO_INFO' | translate }}:
          <span class="font-medium text-gray-800">
            {{ video.videoFile?.name || 'Vimeo ID: ' + video.vimeoId }}
          </span>
        </p>
      </div>

      <div class="mb-4">
        <div class="titre4Modal mb-3">{{ 'PACKAGES_PERSO_MANAGEMENT.SELECT_LANGUAGES_FOR_VIDEO' | translate }}:
        </div>

        <div class="flex flex-col space-y-2">
          @if (selectedLanguages['FR']) {
            <div class="flex items-center">
              <input type="checkbox" id="edit-lang-fr" [(ngModel)]="editLanguageSelection['FR']"
                (ngModelChange)="onLanguageChange('FR')"
                [disabled]="!isLanguageAvailableForEdit('FR') || (!canDeselectLanguage('FR') && editLanguageSelection['FR'])"
                class="form-checkbox h-5 w-5 text-rougeNovo border-gray-300 rounded mr-2 focus:outline-none focus:ring-0" />
                <label for="edit-lang-fr" class="lang-label"
                  [class.text-gray-400]="!canDeselectLanguage('FR') && editLanguageSelection['FR']">
                  Français
                </label>
                @if (!isLanguageAvailableForEdit('FR') && !video.languages.includes('FR')) {
                  <span
                    class="ml-2 text-xs text-amber-600">
                    ({{ 'PACKAGES_PERSO_MANAGEMENT.LANGUAGE_ALREADY_USED' | translate }})
                  </span>
                }
              </div>
            }

            @if (selectedLanguages['EN']) {
              <div class="flex items-center">
                <input type="checkbox" id="edit-lang-en" [(ngModel)]="editLanguageSelection['EN']"
                  (ngModelChange)="onLanguageChange('EN')"
                  [disabled]="!isLanguageAvailableForEdit('EN') || (!canDeselectLanguage('EN') && editLanguageSelection['EN'])"
                  class="form-checkbox h-5 w-5 text-rougeNovo border-gray-300 rounded mr-2 focus:outline-none focus:ring-0" />
                  <label for="edit-lang-en" class="lang-label"
                    [class.text-gray-400]="!canDeselectLanguage('EN') && editLanguageSelection['EN']">
                    English
                  </label>
                  @if (!isLanguageAvailableForEdit('EN') && !video.languages.includes('EN')) {
                    <span
                      class="ml-2 text-xs text-amber-600">
                      ({{ 'PACKAGES_PERSO_MANAGEMENT.LANGUAGE_ALREADY_USED' | translate }})
                    </span>
                  }
                </div>
              }

              @if (selectedLanguages['ES']) {
                <div class="flex items-center">
                  <input type="checkbox" id="edit-lang-es" [(ngModel)]="editLanguageSelection['ES']"
                    (ngModelChange)="onLanguageChange('ES')"
                    [disabled]="!isLanguageAvailableForEdit('ES') || (!canDeselectLanguage('ES') && editLanguageSelection['ES'])"
                    class="form-checkbox h-5 w-5 text-rougeNovo border-gray-300 rounded mr-2 focus:outline-none focus:ring-0" />
                    <label for="edit-lang-es" class="lang-label"
                      [class.text-gray-400]="!canDeselectLanguage('ES') && editLanguageSelection['ES']">
                      Español
                    </label>
                    @if (!isLanguageAvailableForEdit('ES') && !video.languages.includes('ES')) {
                      <span
                        class="ml-2 text-xs text-amber-600">
                        ({{ 'PACKAGES_PERSO_MANAGEMENT.LANGUAGE_ALREADY_USED' | translate }})
                      </span>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="mt-3 p-3 bg-blue-50 rounded-md border border-blue-200 flex items-center justify-center info-box">
              <p class="text-xs text-blue-700 info-text">
                <mat-icon class="text-blue-600 text-sm mr-1">info</mat-icon>
                {{ 'PACKAGES_PERSO_MANAGEMENT.AT_LEAST_ONE_LANGUAGE_REQUIRED' | translate }}
              </p>
            </div>
          </div>

        </div>
        <div class="py-2 px-4 border-t border-gray-300 dark:border-gray-600 flex-shrink-0 flex justify-end">
          <button type="button" (click)="onClose()" class="btn-secondary-novo">
            {{ 'PACKAGES_PERSO_MANAGEMENT.CANCEL' | translate }}
          </button>
          <button type="button" (click)="onSave()" class="btn-primary-novo">
            {{ 'PACKAGES_PERSO_MANAGEMENT.SAVE_CHANGES' | translate }}
          </button>
        </div>
      </div>